import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface TutorContext {
    source: 'detail-view' | 'player';
    contentType: string;
    contentId: string | number;
    contentTitle: string;
    contentDescription: string;
    sectionId?: string | number;
    sectionTitle?: string;
    sectionDescription?: string;
    activityId?: string | number;
    activityTitle?: string;
    activityDescription?: string;
}

@Injectable({ providedIn: 'root' })
export class TutorContextStateService {
    private contextSubject = new BehaviorSubject<TutorContext | null>(null);
    currentContext$ = this.contextSubject.asObservable();

    get currentContext(): TutorContext | null {
        return this.contextSubject.getValue();
    }

    get hasContext(): boolean {
        return !!this.contextSubject.getValue();
    }

    setContext(ctx: TutorContext): void {
        this.contextSubject.next(ctx);
    }

    clearContext(): void {
        this.contextSubject.next(null);
    }
}
